<template>
    <div class="activityList">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="activityList"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <span slot="label" class="label"
                            ><!-- <i class="el-icon-box"></i> -->{{
                                item.name
                            }}
                            {{ item.total }}</span
                        >
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                        @keydown.enter.native="activityList"
                    >
                        <el-form-item label="活动名称" size="small">
                            <el-input
                                clearable
                                placeholder="请输入活动名称"
                                size="small"
                                v-model="searchForm.title"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="活动地点" size="small">
                            <el-input
                                clearable
                                placeholder="请输入活动地点"
                                size="small"
                                v-model="searchForm.address"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系人姓名" size="small">
                            <el-input
                                clearable
                                placeholder="请输入联系人姓名"
                                size="small"
                                v-model="searchForm.contact_name"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" size="small">
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                size="small"
                                v-model.number="searchForm.contact_phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                            >
                                重置条件
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="activityList(1)"
                    >
                        查询
                    </el-button>
                    <!-- <el-button
                        type="danger"
                        icon="el-icon-circle-close"
                        size="small"
                        @click="clean"
                    >
                        清空
                    </el-button> -->
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                        @keydown.enter.native="activityList"
                    >
                        <el-form-item label="活动名称" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入活动名称"
                                size="mini"
                                v-model="searchForm.title"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系人姓名" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入联系人姓名"
                                size="mini"
                                v-model="searchForm.contact_name"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                size="mini"
                                v-model.number="searchForm.contact_phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            >
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="activityList(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth.slice(0, 2)">
                            <el-button
                                type="primary"
                                :key="item.id"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                        <el-dropdown
                            v-if="menuAuth.length > 2"
                            @command="authFunc"
                            style="margin-left: 10px"
                        >
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-arrow-down"
                            >
                                更多操作
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :key="item.id"
                                    v-for="item in menuAuth.slice(2)"
                                    :command="item.funcName"
                                >
                                    <i :class="item.icon"> </i>
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-else></div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>

            <div class="table" :style="{ height: $store.state.index.screen }">
                <el-table
                    :data="tableData"
                    ref="tableData"
                    v-loading="loading"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        align="left"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="活动名称"
                        property="title"
                        min-width="200"
                        align="left"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="主办方"
                        property="sponsor"
                        width="120"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="联系人姓名"
                        property="contact_name"
                        width="120"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="联系电话"
                        property="contact_phone"
                        width="120"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="活动时间"
                        align="left"
                        width="220"
                    >
                        <template slot-scope="scope">
                            <p>开始时间 : {{ scope.row.start_time }}</p>
                            <p>结束时间 : {{ scope.row.end_time }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="报名人数"
                        property=""
                        width="80"
                        align="left"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.sign_up_total == 0">
                                {{ scope.row.sign_up_total }}
                            </span>
                            <span
                                v-else
                                class="clickable"
                                @click="info(scope.row)"
                            >
                                {{ scope.row.sign_up_total }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="当前状态" align="left" header-align="center" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 1 ||
                                    scope.row.status == 5
                                        ? 'info'
                                        : scope.row.status == 10
                                        ? 'warning'
                                        : scope.row.status == 20
                                        ? 'success'
                                        : 'danger'
                                "
                            >
                                {{ scope.row.status_cn }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        width="80"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="创建时间"
                        width="140"
                        property="create_time"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <!-- <el-popconfirm
                                        v-else
                                        :title="'确定' + item.name + '?'"
                                        @onConfirm="rowDo(scope.row, item)"
                                    >
                                        <el-button
                                            slot="reference"
                                            type="text"
                                            size="small"
                                            :class="
                                                item.name == '删除'
                                                    ? 'redText'
                                                    : ''
                                            "
                                            >{{ item.name }}</el-button
                                        >
                                    </el-popconfirm> -->
                                    <popConfirm
                                        v-else
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>

            <activityDetail
                :detailVisible.sync="detailVisible"
                :tableItem="tableItem"
            ></activityDetail>
            <activityEdit
                :editVisible.sync="editVisible"
                :tableItem="tableItem"
                :special="special"
            ></activityEdit>
            <activityAdd :addVisible.sync="addVisible"></activityAdd>
            <activityInfo
                :infoVisible.sync="infoVisible"
                :tableItem="tableItem"
            ></activityInfo>
        </div>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import advancedSearch from "@/comon/components/advancedSearch";
import popConfirm from "@/comon/components/popConfirm";

export default {
    mixins: [tableMixin],
    data() {
        return {
            searchForm: {
                title: "",
                contact_name: "",
                contact_phone: "",
                status: "0",
                address: "",
            },
            menuId: "",
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            tableItem: [],
            detailVisible: false,
            addVisible: false,
            infoVisible: false,

            selectionUserIdList: [],
            orderby_entry: null,
            orderby_workday: null,

            drawerVisible: false,
            editVisible: false,
            statusList: [],
            special: false,
        };
    },
    methods: {
        detail(row) {
            //console.log(row);
            this.tableItem = row;
            this.detailVisible = true;
        },
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                title: "",
                contact_name: "",
                contact_phone: "",
                status: "0",
                address: "",
            };
            this.activityList();
        },
        info(row) {
            //console.log(row);
            this.infoVisible = true;
            this.tableItem = row;
        },
        /**
         * 批量删除
         */
        batchDel() {
            if (this.selectionUserIdList.length > 0) {
                this.$confirm("是否批量删除选中的数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        oaApi
                            .eventsBatchDelete({
                                ids: this.selectionUserIdList.toString(),
                            })
                            .then((res) => {
                                //console.log(res);
                                if (res.code == 200) {
                                    this.$message.success("删除成功！");
                                    this.activityList();
                                } else {
                                    this.$message.error("删除失败！");
                                }
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } else {
                this.$message.warning("请勾选要删除的数据");
            }
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取活动列表
         */
        activityList(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .activityList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        /* this.$nextTick(() => {
                            this.resetTabActivePosition(this.$refs.tabs.$el);
                        }); */
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                        this.closeDrawer();
                        this.$refs.tableData.doLayout();
                    }
                });
        },

        resetTabActivePosition($el) {
            var activeEl = $el.querySelector(".el-tabs__item.is-active");
            //console.log(activeEl);
            var lineEl = $el.querySelector(".el-tabs__active-bar");
            if (activeEl) {
                var style = getComputedStyle(activeEl);
                var pl = style.paddingLeft.match(/\d+/)[0] * 1;
                var pr = style.paddingRight.match(/\d+/)[0] * 1;
                var w = style.width.match(/\d+/)[0] * 1;
                lineEl.style.transform =
                    "translateX(" + (activeEl.offsetLeft + pl) + "px)";
                lineEl.style.width = w - pl - pr + "px";
            }
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.activityList();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "查看") {
                this.detail(row);
            } else if (item.name == "编辑") {
                this.special = false;
                this.edit(row);
            } else if (item.name == "删除") {
                /* this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => */
                oaApi.activityList({}, "delete", row.id).then((res) => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success(`${item.name}成功`);
                            this.activityList();
                        }
                    }
                });
                /* )
                    .catch(() => {
                        this.$message.info("已取消操作");
                    }); */
            } else if (item.name == "完结") {
                this.updateStatus(item, row.id, 20);
            } else if (item.name == "开始") {
                this.updateStatus(item, row.id, 10);
            } else if (item.name == "提交") {
                this.updateStatus(item, row.id, 5);
            } else if (item.name == "取消") {
                this.updateStatus(item, row.id, 99);
            } else if (item.name == "回顾") {
                this.special = true;
                this.edit(row);
            }
        },
        edit(row) {
            this.tableItem = row;
            this.editVisible = true;
        },
        // 回车事件
        enterKeyUp(e) {
            let key = window.event.keyCode || e.keyCode;
            if (key === 13) {
                this.activityList(1);
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
        /**
         * 列表筛选
         */
        sortChange(column) {
            this.orderby_entry = null;
            this.orderby_workday = null;
            if (column.prop == "entry_date") {
                if (column.order == "descending") {
                    this.orderby_entry = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_entry = "asc";
                }
            }
            if (column.prop == "work_day") {
                if (column.order == "descending") {
                    this.orderby_workday = "desc";
                } else if (column.order == "ascending") {
                    this.orderby_workday = "asc";
                }
            }
            this.activityList();
        },
        /**
         * 修改活动的状态
         */
        updateStatus(item, id, status) {
            /* this.$confirm(`确定${item.name}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => { */
            oaApi.eventsUpdateStatus({ id, status }, "get").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success(`${item.name}成功`);
                        this.activityList();
                    }
                }
            });
            /* })
                .catch(() => {
                    this.$message.info("已取消操作");
                }); */
        },
    },
    created() {
        this.activityList();
        document.addEventListener("keydown", this.enterKeyUp);
    },
    destroyed() {
        document.removeEventListener("keydown", this.enterKeyUp);
    },
    components: {
        pagination: pagination,
        advancedSearch: advancedSearch,
        popConfirm: popConfirm,
        activityDetail: () => import("./activityRecord/detail.vue"),
        activityEdit: () => import("./activityRecord/edit.vue"),
        activityAdd: () => import("./activityRecord/add.vue"),
        activityInfo: () => import("./activityRecord/info.vue"),
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.activityList();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.activityList();
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
};
</script>
<style lang="scss">
.activityList {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .tableCont {
        // width: calc(100% - 250px);
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            // padding: 0 20px;
            // .el-scrollbar__wrap {
            //     overflow-x: hidden;
            // }
            .nameCont {
                display: flex;
                align-items: center;
                justify-content: center;
                .headImg {
                    height: 16px;
                    width: 16px;
                    border-radius: 8px;
                    overflow: hidden;
                    margin-right: 8px;
                }
                .memberName {
                    line-height: 24px;
                }
            }
            .clickable {
                color: $theme-color;
                text-decoration: underline;
                cursor: pointer;
                user-select: none;
                &:active {
                    color: #f77f34;
                }
            }
        }
    }
    // .el-scrollbar__wrap {
    //     overflow-x: hidden;
    // }
}
</style>
